import { combineReducers } from 'redux';
import requestsReducer from './domain/requests/RequestReducer';
import { CLEAR_VIA_STATE } from './viaActions';
import usersReducer from './domain/users/userReducer';
import damageAreasReducer from './domain/damageAreas/damageAreasReducer';
import damageAreaUiReducer from './ui/configuration/inspection/damageAreaUiReducer';
import damageTypesReducer from './domain/damageTypes/damageTypeReducer';
import damageTypeUiReducer from './ui/configuration/inspection/damageTypeUiReducer';
import modelTypesReducer from './domain/modelTypes/modelTypeReducer';
import loginReducer from './ui/login/loginUiReducer';
import sessionReducer from './ui/application/sessionUiReducer';
import inspectionReasonReducer from './domain/inspectionReasons/inspectionReasonReducer';
import inspectionReasonUiReducer from './ui/configuration/inspection/inspectionReasonUiReducer';
import videoOptionReducer from './domain/videoOption/videoOptionReducer';
import videoOptionUiReducer from './ui/configuration/inspection/videoOptionUiReducer';
import appConfigReducer from './domain/appConfig/appConfigReducer';
import checklistsReducer from './domain/checklists/checklistsReducer';
import checklistCategoriesReducer from './domain/checklistCategories/checklistCategoriesReducer';
import checklistItemsReducer from './domain/checklistItems/checklistItemsReducer';
import checklistsConfigReducer from './domain/checklistsConfig/checklistsConfigReducer';
import checklistsConfigUiReducer from './ui/configuration/inspection/checklistConfigUiReducer';
import registrationReducer from './ui/login/registration/registrationUiReducer';
import userUiReducer from './ui/configuration/users/userUiReducer';
import passwordUiReducer from './ui/configuration/users/passwordUiReducer';
import inspectionUiReducer from './ui/inspection/inspectionUiReducer';
import inspectionReducer from './domain/inspection/inspectionReducer';
import vehicleReducer from './domain/vehicles/vehicleReducer';
import outcomeReducer from './domain/outcomes/outcomeReducer';
import inspectionDamageReducer from './domain/inspection/inspectionDamageReducer';
import inspectionNoteReducer from './domain/inspectionNotes/inspectionNoteReducer';
import damageTypeReferencesReducer from './domain/damageTypes/damageTypeReferencesReducer';
import emailUiReducer from './ui/configuration/users/emailUiReducer';
import vehicleUiReducer from './ui/configuration/vehicles/vehicleUiReducer';
import vehicleDiagramsReducer from './domain/vehicleDiagrams/vehicleDiagramReducer';
import companyUiReducer from './ui/configuration/company/companyUiReducer';
import companyReducer from './domain/company/companyReducer';
import viaSearchUIReducer from './ui/application/viaSearchUIReducer';
import inspectionSummaryReducer from './domain/inspection/inspectionSummaryReducer';
import emailsReducer from './domain/emails/emailReducer';
import checklistCategoryUiReducer from './ui/configuration/inspection/checklistCategoryUiReducer';
import checklistCategoryReferencesReducer from './domain/checklistCategories/checklistCategoryReferencesReducer';
import purchaseCreditsUiReducer from './ui/purchase/purchaseCreditsUiReducer';
import checklistItemUiReducer from './ui/configuration/inspection/checklistItemUiReducer';
import checklistItemReferencesReducer from './domain/checklistItems/checklistItemReferencesReducer';
import creditPackageReducer from './domain/credits/creditPackageReducer';
import packageUiReducer from './ui/configuration/packages/packageUiReducer';
import packageReducer from './domain/packages/packageReducer';
import purchaseHistoryReducer from './domain/purchases/purchaseHistoryReducer';
import userSummaryReducer from './domain/users/userSummaryReducer';
import appConfigUiReducer from './ui/application/appConfigUiReducer';
import legalDocumentReducer from './domain/legalDocuments/legalDocumentReducer';
import legalDocumentsUiReducer from './ui/configuration/bynx/legalDocumentUiReducer';
import translationsReducer from './domain/appConfig/translationsReducer';
import translationUiReducer from './ui/application/translationUiReducer';
import dashboardDataReducer from './domain/dashboard/dashboardDataReducer';
import dashboardReducer from './ui/application/dashboardUiReducer';
import inspectionListReducer, { inspectionListAllReducer } from './domain/inspections/inspectionListReducer';
import inspectionListUIReducer from './ui/inspections/inspectionListUiReducer';
import taxUiReducer from './ui/configuration/taxes/taxUiReducer';
import taxRateReducer from './domain/taxes/taxRateReducer';
import financialReducer from './domain/financial/financialReducer';
import financialUiReducer from './ui/reports/financial/financialUiReducer';
import supportUiReducer from './ui/support/supportUiReducer';
import notificationReducer from './domain/notification/NotificationReducer';
import notificationUIReducer from './ui/notification/NotificationUiReducer';
import locationReducer from './domain/locations/locationReducer';
import locationUIReducer from "./ui/configuration/location/locationUIReducer";
import bucketReducer from "./domain/buckets/bucketReducer";
import bucketUiReducer from "./ui/credits/bucketUiReducer";
import customerCreditReducer from "./domain/credits/customerCreditReducer";
import customerCreditsUiReducer from "./ui/credits/customerCreditsUiReducer";
import creditBalanceReducer from "./domain/credits/creditBalanceReducer";
import overallBalanceReducer from "./domain/credits/overallBalanceReducer";
import emailRecipientReducer from "./domain/communication/emailRecipientReducer";
import emailRecipientsUiReducer from './ui/configuration/communication/emailRecipientsUiReducer';

const domainReducer = combineReducers({
  requests: requestsReducer,
  users: usersReducer,
  dashboardData: dashboardDataReducer,
  inspectionList: inspectionListReducer,
  inspectionListAll: inspectionListAllReducer,
  inspections: inspectionReducer,
  inspectionDamages: inspectionDamageReducer,
  inspectionNotes: inspectionNoteReducer,
  inspectionSummaries: inspectionSummaryReducer,
  vehicles: vehicleReducer,
  outcomes: outcomeReducer,
  damageAreas: damageAreasReducer,
  inspectionReasons: inspectionReasonReducer,
  damageTypes: damageTypesReducer,
  modelTypes: modelTypesReducer,
  checklists: checklistsReducer,
  videoOption: videoOptionReducer,
  appConfig: appConfigReducer,
  damageTypeReferences: damageTypeReferencesReducer,
  checklistsConfig: checklistsConfigReducer,
  categories: checklistCategoriesReducer,
  items: checklistItemsReducer,
  vehicleDiagrams: vehicleDiagramsReducer,
  company: companyReducer,
  emails: emailsReducer,
  creditPackages: creditPackageReducer,
  creditBalances: customerCreditReducer,
  bucketBalances: creditBalanceReducer,
  overallBucketBalance: overallBalanceReducer,
  checklistCategoryReferences: checklistCategoryReferencesReducer,
  checklistItemReferences: checklistItemReferencesReducer,
  packages: packageReducer,
  taxRates: taxRateReducer,
  purchases: purchaseHistoryReducer,
  userSummaries: userSummaryReducer,
  legalDocuments: legalDocumentReducer,
  translations: translationsReducer,
  financial: financialReducer,
  notifications: notificationReducer,
  locations: locationReducer,
  buckets: bucketReducer,
  emailRecipients: emailRecipientReducer,
});

const uiReducer = combineReducers({
  application: combineReducers({ session: sessionReducer, viaSearch: viaSearchUIReducer }),
  login: loginReducer,
  dashboardData: dashboardReducer,
  inspectionList: inspectionListUIReducer,
  inspection: inspectionUiReducer,
  damageAreas: damageAreaUiReducer,
  inspectionReasons: inspectionReasonUiReducer,
  registration: registrationReducer,
  videoOptions: videoOptionUiReducer,
  appConfigs: videoOptionUiReducer,
  users: userUiReducer,
  passwords: passwordUiReducer,
  damageTypes: damageTypeUiReducer,
  checklistsConfig: checklistsConfigUiReducer,
  checklists: checklistsReducer,
  categories: checklistCategoriesReducer,
  checklistCategories: checklistCategoryUiReducer,
  checklistItems: checklistItemUiReducer,
  items: checklistItemsReducer,
  email: emailUiReducer,
  vehicles: vehicleUiReducer,
  company: companyUiReducer,
  purchaseCredits: purchaseCreditsUiReducer,
  packages: packageUiReducer,
  taxes: taxUiReducer,
  appConfig: appConfigUiReducer,
  legalDocuments: legalDocumentsUiReducer,
  translations: translationUiReducer,
  financial: financialUiReducer,
  support: supportUiReducer,
  notifications: notificationUIReducer,
  locations: locationUIReducer,
  buckets: bucketUiReducer,
  creditBalances: customerCreditsUiReducer,
  bucketBalances: creditBalanceReducer,
  emailRecipients: emailRecipientsUiReducer,
});


export default (state = {}, action) => {
  if (action.type === CLEAR_VIA_STATE) {
    // Wipe all the current state away.
    state = undefined; // eslint-disable-line no-param-reassign
  }

  return combineReducers({
    ui: uiReducer,
    domain: domainReducer,
  })(state, action);
};
